export enum ActionType {
	ADD_STATE = "history/ADD_STATE" , 
	ROLL_BACK_STATE = "history/ROLL_BACK_STATE", 
	SET_STATE = "history/SET_STATE"
}